/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { useState } from 'react';
import { useSignOut } from 'react-auth-kit';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import CustomButton from '../CustomElements/CustomButton';
import useTranslations from '../../customHook/useTranslations';
import { logoutUser } from '../../redux/actions/user.action';
import translations from '../../content/MainHeader/mainHeaderTranslations.json';
import '../../styles/HeaderForObject.css';

/**
 *
 * @param onFilterSubmit
 * @param searchInput
 *  @param show
 * @param onFilterChange {(value: string, forced?: boolean)=>void}
 * @returns {Element}
 * @constructor
 */
function HeaderForObject({ onFilterSubmit, searchInput, onFilterChange, show = true }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();
  // получение словаря для статических данных в зависимости от выбранного языка
  const t = useTranslations(translations);

  const navigate = useNavigate();
  const signOut = useSignOut();
  const user = useSelector((state) => state.user);

  const [isHovered, setIsHovered] = useState(false);

  function logout() {
    dispatch(logoutUser({ logout: true }));
    signOut();
    navigate('/login');
  }

  return (
    <div className={`container-fluid d-flex flex-nowrap flex-row gap-3 header-for-object ${show ? '' : 'end'}`}>
      {show && (
        <div style={{ position: 'relative' }}>
          <input
            id="submit_search"
            autoComplete="off"
            className="header-for-object_input"
            placeholder={t?.searchPlaceholder}
            value={searchInput}
            onChange={(e) => {
              onFilterChange(e);
            }}
            onKeyDown={(e) => {
              if (e.key == 'Enter') onFilterSubmit?.(searchInput);
              if (e.key == 'Escape') {
                onFilterChange({ target: { value: '' } });
                setTimeout((searchInput) => {
                  onFilterSubmit?.(searchInput);
                }, 0);
              }
            }}
          />
          {searchInput && ( // Крестик появляется, только если есть текст
            <div
              onClick={(event) => {
                onFilterChange({ target: { value: '' } });
                setTimeout((searchInput) => {
                  onFilterSubmit?.(searchInput);
                }, 0);
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{
                position: 'absolute',
                top: '50%',
                right: 0,
                transform: 'translateY(-50%)',
                padding: 'var(--sadr-font-size-8)',
              }}
            >
              <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                <path
                  d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
                  fill={isHovered ? '#D30630' : '#000'}
                ></path>
              </svg>
            </div>
          )}
        </div>
      )}
      {show && (
        <CustomButton
          type="button"
          className="header-for-object_btn-search me-auto white-on-hover "
          color={'var(--sadr-background-secondary)'}
          text={t?.findButton}
          colorText={`var(--sadr-text-color)`}
          onClick={(e) => onFilterSubmit?.(searchInput)}
        />
      )}
      <div className="d-flex flex-row gap-3" style={{ height: 'var(--sadr-font-size-60)' }}>
        <div className="d-flex flex-column align-items-center align-self-center user-info">
          {/* <span className="header-for-object_text-user">{user?.fullName}</span>
          <span className="header-for-object_text-rople">{user?.position}</span> */}
          <span className="header-for-object_text-user">{user?.fullName}</span>
          <span className="header-for-object_text-role w-100">{user?.role && user?.role.join(', ')}</span>
        </div>
        <button type="button" className="btn btn-dark header-for-object_btn-logout" href="#" onClick={logout}>
          {t?.logoutButton}
          <img className="header-for-object_icon" src="/image/exit.svg" alt=""></img>
        </button>
      </div>
    </div>
  );
}

export default HeaderForObject;
